import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = () => {
  const token = useSelector((state) => state.auth.token);
  // If token exists, allow access to the requested route; otherwise, redirect to login
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
